// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:41:45

export default {
  "id": "building-mods-for-minecraft",
  "slug": "building-mods-for-minecraft",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2691c4b1c55a417bb620c7ce1e662be1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2691c4b1c55a417bb620c7ce1e662be1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Building Mods For Minecraft",
      "description": "Building Mods For Minecraft is the ultimate game for those who love to build and fight. If you’re a Minecraft fan looking for a new adventure, this game takes the building mechanics of Minecraft to the next level, combining construction with action. You’ll have access to a wide range of building tools and guns.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Adventure",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "fighting",
        "guns",
        "minecraft"
      ]
    },
    "zh-CN": {
      "title": "为Minecraft构建模组",
      "description": "为Minecraft制作建筑模组是喜爱建筑和战斗者的终极游戏。如果你是寻找新冒险的Minecraft粉丝，这款游戏将Minecraft的建筑机制提升到新高度，将建筑与动作相结合。你将能够使用各种建筑工具和枪械。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险",
        "模拟"
      ],
      "tags": [
        "街机",
        "格斗",
        "枪械",
        "我的世界"
      ]
    },
    "zh-TW": {
      "title": "為《Minecraft》建立模組",
      "description": "為《Minecraft》製作建築模組是愛建築與戰鬥者的絕佳遊戲。如果你是《Minecraft》的粉絲並尋找新冒險，這款遊戲將《Minecraft》的建築機制帶到新境界，結合建築與動作元素。你將能夠使用多種建築工具與槍械。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "電玩",
        "格鬥",
        "槍械",
        "Minecraft"
      ]
    },
    "zh-HK": {
      "title": "為 Minecraft 建造模組",
      "description": "為Minecraft建立模組是愛建築和戰鬥的人的最終遊戲。如果你是尋找新冒險的Minecraft粉絲，這款遊戲將Minecraft的建築機制提升至下一級，結合建築與動作。你將獲得各種建築工具和槍械。",
      "instructions": "用滑鼠點擊或按鈕操作以遊戲",
      "genres": [
        "冒險",
        "模擬"
      ],
      "tags": [
        "電玩",
        "格鬥",
        "槍械",
        "Minecraft"
      ]
    },
    "ja": {
      "title": "Minecraftのためのビルドモッド作成",
      "description": "Minecraftのビルドモッドは、建築と戦闘を好む人々にとっての究極のゲームです。Minecraftのファンで新しい冒険を探している人にとって、このゲームはMinecraftの建築メカニズムを次のレベルに引き上げ、建築とアクションを組み合わせています。幅広い建築ツールと銃にアクセスできます。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "アドベンチャー",
        "シミュレーション"
      ],
      "tags": [
        "アーケード",
        "格闘",
        "銃",
        "マインクラフト"
      ]
    },
    "ko": {
      "title": "마인크래프트용 빌딩 모드 만들기",
      "description": "Minecraft의 빌딩 모드는 건설하고 싸우는 것을 사랑하는 사람들에게 최상의 게임입니다. 새로운 모험을 찾는 Minecraft 팬이라면, 이 게임은 Minecraft의 건설 메커니즘을 한 단계 업그레이드시키며, 건설과 액션을 결합한 게임입니다. 다양한 건설 도구와 총기를 사용할 수 있습니다.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "모험",
        "시뮬레이션"
      ],
      "tags": [
        "아케이드",
        "전투",
        "총",
        "마인크래프트"
      ]
    },
    "fr": {
      "title": "Construire des Mods pour Minecraft",
      "description": "Construire des Mods pour Minecraft est le jeu ultime pour ceux qui aiment construire et se battre. Si vous êtes un fan de Minecraft à la recherche d'une nouvelle aventure, ce jeu emmène les mécanismes de construction de Minecraft au niveau supérieur, combinant construction et action. Vous aurez accès à une large gamme d'outils de construction et d'armes à feu.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Aventure",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "combats",
        "armes à feu",
        "Minecraft"
      ]
    }
  }
};
